import { SET_PRODUCT_CLICK } from './../const';

export default (clicked) => {
    return {type: SET_PRODUCT_CLICK, clicked}
}
